import {isAnyOf} from '@reduxjs/toolkit'

import {APIStatus, ClosingMethod, OrderPhase} from '@web/core/constants'
import {examineUrlSafety} from '@web/helpers/path'
import makeSlice from '@web/slices/common/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const isFetchingAction = isAnyOf(initOrderSheetByAPI.pending)
const isResolvedAction = isAnyOf(initOrderSheetByAPI.fulfilled)

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {
                    data: {orderSheetId, saleChannelType, sellerRegisterType, shoppingLiveConfigInfo},
                    backUrl,
                } = payload

                state.seqID = orderSheetId
                state.entry = saleChannelType
                state.entryPoint = sellerRegisterType ?? null
                state.backUrl = examineUrlSafety(backUrl, '') || null
                state.closingType = shoppingLiveConfigInfo ? ClosingMethod.BACK : ClosingMethod.REPLACE
                state.orderPhase = OrderPhase.CHECKOUT
            })
            .addMatcher(isFetchingAction, (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(isResolvedAction, (state) => {
                state.scene = APIStatus.RESOLVED
            })
    },
})

export default slice.reducer
